import React, { Component } from 'react';
import { Container, Table } from 'semantic-ui-react';
import { PtSelect, PtRadio } from '../../../grit-utilities';
import ScrollArea from 'react-scrollbar';
import DropdownLib from '../../../DropdownLib';

export default class Signing extends Component {

    constructor(props) {
        super(props);
        const { minorModel } = this.props;
        this.state = minorModel.signing;
    }

    render() {
        const { postedWeightOptions, grossVehicleWeightLimit } = DropdownLib.getDropdowns().MS_Signing;
        const yesNoOptions = [
            { key: 0, label: 'N/A', value: 0 },
            { key: 1, label: 'Yes', value: 1 },
            { key: 2, label: 'No', value: 2 },
        ]
        return (
            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>

                    <Table definition>
                        {!window.mobileAndTabletcheck() && <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell />
                                <Table.HeaderCell>GVW Limit(Lbs)</Table.HeaderCell>
                                <Table.HeaderCell>Axle Limit(Tons)</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>}

                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>All Configurations</Table.Cell>
                                <Table.Cell><PtSelect label={window.mobileAndTabletcheck() && "GVW Limit(Lbs)"} options={grossVehicleWeightLimit} name="allConfigGVW" disabled={this.props.disabled}
                                    defaultVal={this.state.allConfigGVW} onChange={this.onChangeDropdown} /></Table.Cell>
                                <Table.Cell><PtSelect label={window.mobileAndTabletcheck() && "Axle Limit(Tons)"} options={postedWeightOptions} name="allConfigPerAxel" disabled={this.props.disabled}
                                    defaultVal={this.state.allConfigPerAxel} onChange={this.onChangeDropdown} /></Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Single Unit</Table.Cell>
                                <Table.Cell><PtSelect label={window.mobileAndTabletcheck() && "GVW Limit(Lbs)"} options={grossVehicleWeightLimit} name="singleUnitGVW" disabled={this.props.disabled}
                                    defaultVal={this.state.singleUnitGVW} onChange={this.onChangeDropdown} /></Table.Cell>
                                <Table.Cell><PtSelect label={window.mobileAndTabletcheck() && "Axle Limit(Tons)"} options={postedWeightOptions} name="singleUnitPerAxel" disabled={this.props.disabled}
                                    defaultVal={this.state.singleUnitPerAxel} onChange={this.onChangeDropdown} /></Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Double Unit</Table.Cell>
                                <Table.Cell><PtSelect label={window.mobileAndTabletcheck() && "GVW Limit(Lbs)"} options={grossVehicleWeightLimit} name="doubleUnitGVW" disabled={this.props.disabled}
                                    defaultVal={this.state.doubleUnitGVW} onChange={this.onChangeDropdown} /></Table.Cell>
                                <Table.Cell><PtSelect label={window.mobileAndTabletcheck() && "Axle Limit(Tons)"} options={postedWeightOptions} name="doubleUnitPerAxel" disabled={this.props.disabled}
                                    defaultVal={this.state.doubleUnitPerAxel} onChange={this.onChangeDropdown} /></Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Multiple Unit</Table.Cell>
                                <Table.Cell><PtSelect label={window.mobileAndTabletcheck() && "GVW Limit(Lbs)"} options={grossVehicleWeightLimit} name="multipleUnitGVW" disabled={this.props.disabled}
                                    defaultVal={this.state.multipleUnitGVW} onChange={this.onChangeDropdown} /></Table.Cell>
                                <Table.Cell><PtSelect label={window.mobileAndTabletcheck() && "Axle Limit(Tons)"} options={postedWeightOptions} name="multipleUnitPerAxel" disabled={this.props.disabled}
                                    defaultVal={this.state.multipleUnitPerAxel} onChange={this.onChangeDropdown} /></Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                    <PtRadio label="Bridge End Marker" options={yesNoOptions} name="bridgeEndMarker" disabled={this.props.disabled}
                        value={this.state.bridgeEndMarker} onChange={this.onChangeRadio} />
                </ScrollArea>
            </Container>
        );
    }

    onChangeDropdown = (e) => {
        const {name, value} = e.target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) });
    }

    onChangeRadio = (e, target) => {
        const {name, value} = target;
        this.props.triggerNeedSave();
        this.setState({ [name]: value });
    }

    componentDidUpdate() {
        this.props.minorModel.signing = this.state;
    }

}


// WEBPACK FOOTER //
// ./src/layers/tabs/minor-structs/signing.js